const HEADER_OFFSET = 80

export function scrollToAnchor(hash: string) {
  const target = document.querySelector(hash)
  if (!target) {
    return
  }
  const top = target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET
  window.scrollTo({ top, behavior: 'smooth' })
}

export function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
